<script>
    import {initializeGsapAnimation} from '../../utils.js';
    import {onMount} from 'svelte';

    let main;
    let img;
    export let scrollPointers;
    export let updatedValue;

    onMount(onStart);
    /**
     */
    function onStart() {
        initializeGsapAnimation(
            main,
            img,
            [
                {scale: '1', top: 'max(53vw,24.537vh)', duration: 3},
                {scale: '1.1', top: 'max(20vw,9.259vh)', duration: 3},
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            scrollPointers,
            [
                {scrollValue: 0, duration: 1},
                {
                    scrollValue: 1,
                    duration: 1,
                    onUpdate: () => {
                        updatedValue = scrollPointers.scrollValue;
                    },
                },
            ],
            3,
        );
    }
</script>

<section bind:this={main}>
    <div class="main-div">
        <div class="text-div">
            <p>ARTISTS <span>&</span></p>
            <p>MUSICIANS</p>
        </div>
        <div class="img" bind:this={img}>
            <img
                src="images/Artist/ArtistMobile/scluptor.png"
                alt="imageofart"
                width="100%"
                height="100%"
            />
        </div>
    </div>
</section>

<style>
    .main-div {
        width: 100%;
        height: max(216.355vw, 100vh);
        background-color: #59e7f2;
        position: relative;
    }
    .text-div {
        position: absolute;
        bottom: max(144.626vw, 66.847vh);
        overflow: hidden;
        width: 100%;
    }
    .img {
        width: 100%;
        height: 100%;
        position: absolute;
        top: max(53vw,24.537vh);
        z-index: 1;
    }
    p span {
        font-family: Oregano;
        font-size: 14.019vw;
        font-weight: 400;
        color: #000000;
    }
    .text-div p:nth-child(1) {
        font-family: Orbitron;
        font-weight: 700;
        font-size: 16.355vw;
        margin: 0;
        margin-left: -3.037vw !important;
        line-height: 13.804vw;
        color: #000000;
    }
    .text-div p:nth-child(2) {
        font-family: Orbitron;
        font-weight: 700;
        font-size: 16.355vw;
        margin: 0;
        line-height: 13.804vw;
        color: #000000;
    }
</style>
